module.exports = __webpack_public_path__ + "img/800152647.0e117df4.png";